<div class="header-bar">
  <h1>Customer Notification Admin</h1>
</div>

<div class="content-container pb-0">
  <div class="card card-w-title">
    <div class="flex flex-column gap-2">
      <div class="sub-title">
        Use the rich text editor below to compose the content of the customer notification banner
        that appears when a customer creates an order.
      </div>

      <quill-editor
        *ngIf="setting"
        [(ngModel)]="setting.value"
        [modules]="editorToolbarOptions"
        (onEditorCreated)="getEditorInstance($event)"
      >
        ></quill-editor
      >

      <div>
        <button
          pButton
          type="button"
          id="save"
          class="ui-button-primary btn-to-right mt-0"
          (click)="save()"
          label="Save"
        ></button>
        <button
          pButton
          type="button"
          id="save"
          class="ui-button-secondary btn-to-right mt-0"
          (click)="clearText()"
          label="Clear"
        ></button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="setting" class="content-container">
  <div class="card card-w-title" style="height: 100%">
    <div>
      <h2 class="sub-header-bar">Preview</h2>
      <div class="sub-title">
        This is how the notification will appear to the customer when creating an order
      </div>
      <div class="order-message-div">
        <div class="icon-container">
          <span class="icon">i</span>
        </div>
        <div class="message-container display-editor">
          <!-- using quill editor to prevent focus issues when editing primeng editor component -->
          <quill-editor
            [(ngModel)]="setting.value"
            [readOnly]="true"
            [styles]="{ border: 'none' }"
            [modules]="{ toolbar: false }"
            class="custom-quill-editor"
          >
          </quill-editor>
        </div>
      </div>
    </div>
  </div>
</div>
